import { SimpleSolverBlock } from '../../../model';

export const DEFAULT_SIMPLE_SOLVER_PROPS: Omit<SimpleSolverBlock, 'id' | 'type'> = {
  initial_super_latex_content: {
    latex_nodes: [{ id: 'default', latex: '$x = 1$' }],
  },
  steps: [],
};
